import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeType = 'blueprint' | 'typewriter';
export type ThemeMode = 'dark' | 'light';

interface ThemeState {
  theme: ThemeType;
  mode: ThemeMode;
  setTheme: (theme: ThemeType) => void;
  setMode: (mode: ThemeMode) => void;
  toggleMode: () => void;
}

/**
 * Apply theme + mode to the <html> element's data attributes.
 * This drives the CSS variable cascade in index.css.
 */
function applyTheme(theme: ThemeType, mode: ThemeMode) {
  document.documentElement.setAttribute('data-theme', theme);
  document.documentElement.setAttribute('data-mode', mode);
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'blueprint',
      mode: 'dark',

      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme, get().mode);
      },

      setMode: (mode) => {
        set({ mode });
        applyTheme(get().theme, mode);
      },

      toggleMode: () => {
        const next = get().mode === 'dark' ? 'light' : 'dark';
        set({ mode: next });
        applyTheme(get().theme, next);
      },
    }),
    {
      name: 'owensroot-theme',
      // Re-apply theme from localStorage on page load
      onRehydrateStorage: () => (state) => {
        if (state) {
          applyTheme(state.theme, state.mode);
        }
      },
    }
  )
);
